import { useEffect, useState } from 'react';

import { APP_CONFIG } from '@/config/app';

/**
 * Debounces a value by the specified delay
 * @param value - The value to debounce
 * @param delay - Delay in milliseconds (defaults to APP_CONFIG.debounce.search)
 */
export function useDebounce<T>(value: T, delay: number = APP_CONFIG.debounce.search): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
